import { useEffect, useState } from "react";

export default function usePromise<T>(promise: () => Promise<T>) {
  const [promiseStatus, setPromiseStatus] = useState<{
    loading: boolean;
    error: boolean;
    success: boolean;
    finished: boolean;
    data?: T;
  }>({
    loading: false,
    error: false,
    success: false,
    finished: false,
    data: undefined,
  });
  useEffect(() => {
    setPromiseStatus((status) => ({ ...status, loading: true }));
    promise()
      .then((data) =>
        setPromiseStatus((status) => ({ ...status, success: true, data }))
      )
      .catch((e) => {
        console.error(e);
        setPromiseStatus((status) => ({ ...status, error: true }));
      })
      .finally(() =>
        setPromiseStatus((status) => ({
          ...status,
          loading: false,
          finished: true,
        }))
      );
  }, [promise]);

  return { ...promiseStatus };
}
